export default "__VITE_ASSET__ba771fe0__"